import { fromJS, List, Map as IMap } from 'immutable';
import moment from 'moment';

import { ProductRecord, PackageRecord } from './../Record/Products';
const NAME_SPACE = 'PRODUCTS/';
const initialState = new ProductRecord({
  package_list: new List([new PackageRecord({
    'price_list': new List([])
  })]),
  loading: true,
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return initialState;
    case NAME_SPACE + 'ADD_PRODUCTS':
      return action.payload.products;
    case NAME_SPACE + 'EDIT_PRODUCTS':
      return state.update((products) => products.merge(action.payload.products));
    case NAME_SPACE + 'ADD_PACKAGE':
      return state.update('package_list', (package_list) => package_list.push(action.payload.package));
    case NAME_SPACE + 'EDIT_PACKAGE':
      return state.update('package_list', (package_list) => {
        return package_list.update(action.payload.index, (item) => {
          return item.merge(action.payload.package)
        });
      });
    case NAME_SPACE + 'DEL_PACKAGE':
      return state.update('package_list', (package_list) => package_list.delete(action.payload.index));
    case NAME_SPACE + 'BATCH_ADD_PRICE':
      return state.update('package_list', (package_list) => {
        return package_list.update(action.payload.index, (item) => {
          return item.update('price_list', (price_list) => {
            const originalPriceList = price_list;
            const price = action.payload.price;
            const dateIntervalOrMultiple = action.payload.price.dateIntervalOrMultiple;
            const { selectType, weekSelect, supplier_id, date } = price.toJS();
            const ldate = (date || []).sort((x, y) => x > y ? 1 : y > x ? -1 : 0);
            const dateDiff = moment(date[1]).diff(moment(date[0]), 'days');
            const _price_list_2 = [];
            if (dateIntervalOrMultiple === 2) {
              for (let i = 0; i < ldate.length; i++) {
                const _tmp = price.merge({
                  'date': [ldate[0], ldate[ldate.length - 1]],
                  'date_price': ldate[i],
                });
                _price_list_2.push(_tmp);
              }
              const result = List(_price_list_2).concat(price_list).filter((set => o => set.has(o.get('date_price')) ? false : set.add(o.get('date_price')))(new Set()));
              return result;
            }
            for (let i = 0; i <= dateDiff; i++) {
              let date_price = moment(price.date[0]).add(i, 'days').format('YYYY-MM-DD');
              let date = moment(date_price).date();
              let index = -1;
              if (selectType === 1) {
                if ((date % 2) === 0) {
                  index = originalPriceList.findIndex((x) => x.get('date_price') === date_price)
                  if (originalPriceList.get(index)) {
                    _price_list_2.push(originalPriceList.get(index))
                  }
                  continue;
                }
              }

              if (selectType === 2) {
                if ((date % 2) !== 0) {
                  index = originalPriceList.findIndex((x) => x.get('date_price') === date_price)
                  if (originalPriceList.get(index)) {
                    _price_list_2.push(originalPriceList.get(index))
                  }
                  continue;
                }
              }

              if (selectType === 3) {
                if (Array.isArray(weekSelect)) {
                  if (weekSelect.length > 0) { // 未选星期不参与计算
                    if (!weekSelect.some(x => parseInt(x, 10) === moment(date_price).days())) {
                      index = originalPriceList.findIndex((x) => x.get('date_price') === date_price)
                      if (originalPriceList.get(index)) {
                        _price_list_2.push(originalPriceList.get(index))
                      }
                      continue;
                    }
                  }
                }
              }
              const _tmp = price.merge({
                // 'ppp_id': price.ppp_id + '-' + date_price + '-' + supplier_id,\
                'date_price': date_price,
              })
              _price_list_2.push(_tmp);
            }
            return List(_price_list_2).concat(price_list).filter((set => o => set.has(o.get('date_price')) ? false : set.add(o.get('date_price')))(new Set()));
          });
        });
      });
    // cache_price_list
    // case NAME_SPACE + 'BATCH_IMPORT_PRICE':
    //   return state.update('package_list', (package_list) => {
    //     return package_list.update(action.payload.index, (item) => {
    //       return item.update('price_list', (price_list) => {
    //         return fromJS(action.payload.data);
    //       });
    //     });
    //   });
    case NAME_SPACE + 'ADD_HM_PACKAGE':
      return state.update('package_list', (package_list) => {
        return package_list.update(action.payload.index, (item) => {
          const item1 = item.update('hm_pp_list', (hmList) => {
            const tkey = action.payload.pg.pp_id;
            const rList = [];
            if (!IMap.isMap(hmList)) {
              hmList = new IMap();
            }
            return hmList.set(String(action.payload.pg.pp_id), action.payload.pg);
          });
          return item1.set('hm_pp_ids', item1.get('hm_pp_list').map(k => k.pp_id).join(','));
        });
      });
    case NAME_SPACE + 'DEL_HM_PACKAGE':
      return state.update('package_list', (package_list) => {
        return package_list.update(action.payload.index, (item) => {
          const item1 = item.update('hm_pp_list', (hmList) => {
            return hmList.delete(String(action.payload.key));
          });
          return item1.set('hm_pp_ids', item1.get('hm_pp_list').map(k => k.pp_id).join(','));
        });
      });
    case NAME_SPACE + 'BATCH_IMPORT_PRICE':
      return state.update('package_list', (package_list) => {
        return package_list.update(action.payload.index, (item) => {
          return item.update('price_list', (price_list) => {
            const plMap = new Map();
            let list = [];
            action.payload.data.forEach((item) => {
              plMap.set(item.date_price, item);
            });
            price_list.forEach((item) => {
              plMap.set(item.get('date_price'), item.toJS());
            });
            plMap.forEach((value) => list.push(value));
            return fromJS(list);
          });
        });
      });
    case NAME_SPACE + 'BATCH_DEL_ALL_PRICE':
      return state.update('package_list', (package_list) => {
        return package_list.update(action.payload.index, (item) => {          
          return item.update('price_list', (price_list) => {
            return List([]);
          });
        });
      });
    case NAME_SPACE + 'ADD_PRICE':
      return state.update('package_list', (package_list) => {
        return package_list.update(action.payload.index, (item) => {
          return item.update('price_list', (price_list) => {
            return price_list.push(action.payload.price);
          });
        });
      });
    case NAME_SPACE + 'EDIT_PRICE':
      return state.update('package_list', (package_list) => {
        return package_list.update(action.payload.index, (item) => {
          return item.update('price_list', (price_list) => {
            return price_list.update(action.payload.jindex, (price) => price.merge(action.payload.price));
          });
        });
      });
    case NAME_SPACE + 'DEL_PRICE':
      return state.update('package_list', (package_list) => {
        return package_list.update(action.payload.index, (item) => {
          return item.update('price_list', (price_list) => price_list.delete(action.payload.jindex));
        });
      });
    case NAME_SPACE + 'RECEIVE_PRODUCTS':
      // action.payload.products.package_list = Object.assign(state.get('package_list').toJS(), action.payload.products.package_list);
      if (action.payload.products.package_list.length < 1) {
        action.payload.products.package_list = List([new PackageRecord({
          'price_list': List([])
        })]);
      }
      action.payload.products.delQueueRackage = List([]);
      action.payload.products.delQueuePrice = List([]);
      action.payload.products.loading = false;
      return fromJS(action.payload.products);
    case NAME_SPACE + 'SET_QUEUE_PACKAGE':
      return state.update('delQueueRackage', x => x.push(action.payload.id));
    case NAME_SPACE + 'SET_QUEUE_PRICE':
      return state.update('delQueuePrice', x => x.concat(action.payload.ids));
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    default:
      return state;
  }
};

const Products = (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return item(undefined, action);
    case NAME_SPACE + 'ADD_PRODUCTS':
      return item(undefined, action);
    case NAME_SPACE + 'EDIT_PRODUCTS':
      return item(state, action);
    case NAME_SPACE + 'ADD_PACKAGE':
      return item(state, action);
    case NAME_SPACE + 'EDIT_PACKAGE':
      return item(state, action);
    case NAME_SPACE + 'DEL_PACKAGE':
      return item(state, action);
    case NAME_SPACE + 'ADD_HM_PACKAGE':
      return item(state, action);
    case NAME_SPACE + 'DEL_HM_PACKAGE':
      return item(state, action);
    case NAME_SPACE + 'BATCH_ADD_PRICE':
      return item(state, action);
    case NAME_SPACE + 'BATCH_DEL_ALL_PRICE':
      return item(state, action);
    case NAME_SPACE + 'BATCH_IMPORT_PRICE':
      return item(state, action);
    case NAME_SPACE + 'ADD_PRICE':
      return item(state, action);
    case NAME_SPACE + 'EDIT_PRICE':
      return item(state, action);
    case NAME_SPACE + 'DEL_PRICE':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_PRODUCTS':
      return item(state, action);
    case NAME_SPACE + 'SET_QUEUE_PACKAGE':
      return item(state, action);
    case NAME_SPACE + 'SET_QUEUE_PRICE':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    default:
      return state;
  }
};

export default Products;

// function monthDay(date) {
//   return [...Array(42).keys()].map((i) => {
//     const startDate = moment(date).date(1);
//     return startDate.weekday(i).date();
//   });
// }
// console.log(monthDay('2019-02-20')); //date格式为moment能识别的格式